import React from 'react';
import './style.css';
import MenuSection from '../common/sections/MenuSection';
import Button from '../common/input/Button';
import VideoButton from '../common/input/VideoButton';
import GridLayout from '../common/GridLayout';
import ImageButton from '../common/input/ImageButton';

const colors = [
    [
        "#000000",
        "#3a3a3a",
        "#424242",
        "#B2B2B2",
        "#DADADA",
        "#EAEAEA",
        "#F3F3F3",
        "#FFFFFF",
    ],

    [
        "#0b3b63",
        "#18446E",
        "#1E70B3",
        "#4C77B6",
        "#4677B2",
        "#0081B6",
        "#78BAF8",
        "#5bc0de",
        "#D2E1F0",
        "#dee6e9",
    ],

    [
        "#53366C",
        "#8657AF",
        "#D7AAFF",
        "#E6D1F9",
    ],

    [
        "#9A2B0C",
        "#E93D0E",
        "#d9534f",
        "#FF8C6C",
        "#F4CCC1",
    ],

    [
        "#8C4D0D",
        "#E77F15",
        "#FF9350",
        "#f0ad4e",
        "#FFC283",
    ],

    [
        "#897715",
        "#D3B300",
        "#FDE145",
        "#F8EBA4",
    ],

    [
        "#0D5B1E",
        "#14922F",
        "#5cb85c",
        "#6AC27D",
        "#BBF0C6",
    ]
];

export default () => (
    <div className="content">
        <h2>Designskisser</h2>

        <p>
            I forbindelse med utvikling av <a href="https://helseomsorg21monitor.no">helseomsorg21monitor.no</a> hadde
            vi
            en interaksjonsdesigner med for å skissere opp løsningen. Hovedhensikten med interaksjonsdesign å lage
            løsninger
            som er brukervennlige, med mindre fokus på det visuelle enn en det vi ville hatt hvis vi brukte en
            (web-)designer.
            Resultatet ble ikke en ren designguide, men et sett med skisser som vi har arbeidet ut i fra, <a
            href="/downloads/design.zip">trykk her for å laste ned</a>.
        </p>

        <h2>Skrifttyper</h2>

        <p>
            Nettsidene bruker skrifttypen <a href="https://fonts.google.com/specimen/Open+Sans">Open sans</a>.
        </p>

        <h2>Farger</h2>

        <p>
            Vi har ikke brukt et strengt definert sett med farger, men her er en samling med de mest brukte på
            helsemonitoren. Det For
            nye sider bør man ikke velge farger som ikke er med i denne samlingen. Det er hovedsakelig brukt blå- og
            gråtoner i større
            komponenter, mens andre farger er brukt til å gjøre siden litt mer fargerik f.eks. ved bruk i grafer.
        </p>

        { colors.map((group, i) =>
            <div className="StylePage-color-group" key={i}>
                {group.map(color => <div key={color} className="StyleGuidePage-color"
                                         style={{background: color}}>{color.toUpperCase()}</div>)}
            </div>
        )}

        <h2>Designkomponenter HRCS</h2>

        <p>
            Nedenfor vises en rekke designkomponenter som vi har brukt til visning for HRCS-nettsiden. Bruk gjerne
            de samme komponentene i skisser for nye sider o.l.
        </p>

        <h3>Introduksjonslenker</h3>

        <MenuSection>
            <Button href="#">Knapp 1</Button>
            <Button href="#">Knapp 2</Button>
            <Button href="#">Knapp 3</Button>
        </MenuSection>

        <h3>Videolenker</h3>

        <GridLayout>
            <VideoButton href="#" title="Bildeknapp 1"/>
            <VideoButton href="#" title="Bildeknapp 2"/>
            <VideoButton href="#" title="Bildeknapp 3"/>
        </GridLayout>

        <h3>Bildelenker</h3>

        <GridLayout>
            <ImageButton
                image="/images/hurtigveiledning.png"
                href="/downloads/1.%20Hurtigveiledning%20forskningsaktivitet%20og%20helsekategorier.pdf"
                title="HRCS-hurtigguide">
                En relativt kortfattet oversikt over helsekategorier og forskningsaktiviteter både på norsk og engelsk.
                Den kan skrives ut på en A3-side.
            </ImageButton>
            <ImageButton
                image="/images/hrcs-common-mistakes.png"
                href="/downloads/3.%20Common%20Mistakes%20HRCS.pdf"
                title="HRCS common mistakes">
                En oversikt noen feilmerkinger som lett kan gjøres når man klassifiserer prosjekter med HRCS
            </ImageButton>
            <ImageButton
                image="/images/hrcs-veiledning.png"
                href="/downloads/2.%20HRCS%20veiledning.pdf"
                title="HRCS-veiledning">
                Komplett veiledning til alle helsekategoriene og forskningsaktivitetene på engelsk.
            </ImageButton>
        </GridLayout>

        <p></p>
    </div>
);


// WEBPACK FOOTER //
// ./src/StyleGuidePage/StyleGuidePageContent.js